<template>
  <div class="bg-lg h-full">
    <toast-message :show="showToast" @close="showToast = false" message="Vous devez séléctionnez une période" />
    <toast-message :show="toast.show" @close="toast.show = false" :color="toast.color" :message="toast.message" style="top: 16px; right: 16px;">
      <span slot="icon">
        <component :is="toast.icon" />
      </span>
    </toast-message>
    <div class="p-5 sm:p-10 grid grid-cols-1">
      <!-- <span class=" col-span-1 font-semibold text-lg text-tex-3 sm:text-black ffamily-pro">{{ $t("homeDash.titleBtn") }}</span> -->

     <!--  <div class=" col-span-1 grid lg:grid-cols-3 lg:gap-8 gap-4 mt-2">
        <routerLink to="/dashboard/recharge"
          class="bg-white col-span-1 flex items-center rounded-lg shadow p-2 focus:outline-none"
          style="text-align: left">
          <span>
            <Iconcompt2 class="m-4 sm:m-6" /></span>
          <div class="flex flex-col " style="color: #222F5A;">
            <span class="font-bold">{{ $t("homeDash.rechargTitle") }}</span>
            <span class="text-sm ffamily-pro"
            v-html="$t('homeDash.rechargSubtitle')" >

            </span>
          </div>
        </routerLink>

        <routerLink to="/dashboard/counters">
            <div @click="addMeter" class=" bg-white col-span-1 flex items-center  rounded-lg shadow p-2 focus:outline-none" style="text-align: left">
              <span><Iconsave class="m-4 sm:m-6" /></span>
              <div class="flex flex-col " style="color: #222F5A;">
                <span class="font-bold">{{ $t("homeDash.saveTitle") }}</span>
                <span class="text-sm ffamily-pro">{{ $t("homeDash.saveSubtitle") }}</span>
              </div>
            </div>
        </routerLink>

        <router-link to="/dashboard/bills"
          class="bg-white  col-span-1 flex items-center  rounded-lg shadow p-2 focus:outline-none"
          style="text-align: left">
          <span>
            <Iconpay class="m-4 sm:m-6" /></span>
          <div class="flex flex-col " style="color: #222F5A;">
            <span class="font-bold">{{ $t("homeDash.addcTitle") }}</span>
            <span class="text-sm ffamily-pro">{{ $t("homeDash.addcSubtitle") }}</span>
          </div>
        </router-link>
      </div> -->

      <div
        class="ffamily-pro col-span-1 font-semibold text-lg mt-12 mb-4 flex justify-between text-tex-3 sm:text-black">
        <span>{{ $t("homeDash.tablTitle") }}</span>

        <!-- large version calendar -->
        <div class="hidden lg:block relative">
          <button @click="calendarActive"
            class="font-semibold px-4 focus:outline-none rounded text-sm border border-black hover:border-radio-50 hover:text-radio-50 flex items-center justify-center">
            <span class="">
              <Iconcalendar /></span>
            <span class="p-1 px-2">{{ selectedFilter}}</span>
            <span>
              <Iconchevroncal /></span>
          </button>
          <div v-if="calendar"
            class="ffmaily-pro absolute text-base mt-2 right-0 -ml-64 flex border border-kborder-500 rounded ">
            <div class=" bg-white p-6 w-48 font-normal lg:border border-kborder-9">
              <ul class="grid gap-4">
                <li :class="i == selectedFilter ? 'text-tex-2' : ''"  v-for="i in calFilter" :key="i.id"><button @click="timeFilter(i)" type="button" class="focus:outline-none">{{ i }}</button></li>
              </ul>
            </div>
            <div class="bg-white py-5 px-5">
              <span class="mb-4">
                <vc-date-picker mode="range" v-model="range" :max-date="new Date()"
                  is-inline title-position="left" :theme="theme" />
              </span>
              <span class="pt-5 pl-3">
                <button type="button" @click="calendar = !calendar"
                  class="border text-kbutton-1 border-kbutton-1 h-search sm:h-minput  hover:border-kbutton-2 hover:text-kbutton-2 active:border active:border-kbutton-3 py-1 sm:py-2 px-4 sm:px-6 text-sm sm:text-base rounded focus:outline-none">
                  {{ $t("homeDash.cancelBtn") }}
                </button>
                <button type="button" @click="applyFilter"
                  class="ml-4 text-white border h-search sm:h-minput bg-kbutton-1 hover:bg-kbutton-2 active:border active:border-kbutton-3 py-1 sm:py-2 px-4 sm:px-6 text-sm sm:text-base rounded focus:outline-none">
                  {{ $t("homeDash.apllyBtn") }}
                </button>
              </span>
            </div>
          </div>
        </div>
        <!-- large version calendar -->
        
        <!-- mobile version calendar -->
        <div class="lg:hidden relative">
          <button @click="calendarActive"
            class="font-semibold px-4 focus:outline-none rounded text-sm border border-black hover:border-radio-50 hover:text-radio-50 flex items-center justify-center">
            <span class="">
              <Iconcalendar /></span>
            <span class="p-1 px-2">{{ selectedFilter}}</span>
            <span>
              <Iconchevroncal /></span>
          </button>
          <div v-if="calendar"
            class="ffmaily-pro absolute text-base mt-2 right-0 -ml-64 flex border border-kborder-500 rounded ">
            <div v-if="!chooseDate" class=" bg-white p-6 w-48 font-normal lg:border border-kborder-9">
              <ul class="grid gap-4">
                <li :class="i == selectedFilter ? 'text-tex-2' : ''" v-for="i in calFilter" :key="i.id"><button @click="timeFilter(i)" type="button" class="focus:outline-none">{{ i }}</button></li>            
                <li @click="chooseDate=true"><button class="flex items-center focus:outline-none" ><span class="text-tex-2 mr-2">{{ $t("homeDash.chooseDate") }}</span><Iconchevrdate/></button></li>
              </ul>
            </div>
            <div v-else class="bg-white py-5 px-5">
              <span class="mb-4">
                <vc-date-picker mode="range" v-model="range" :max-date="new Date()"
                  is-inline title-position="left" :theme="theme" />
              </span>
              <span class="pt-5 pl-3">
                <button type="button" @click="calendar = !calendar"
                  class="border text-kbutton-1 border-kbutton-1 h-search sm:h-minput  hover:border-kbutton-2 hover:text-kbutton-2 active:border active:border-kbutton-3 py-1 sm:py-2 px-4 sm:px-6 text-sm sm:text-base rounded focus:outline-none">
                  {{ $t("homeDash.cancelBtn") }}
                </button>
                <button type="button" @click="applyFilter"
                  class="ml-4 text-white border h-search sm:h-minput bg-kbutton-1 hover:bg-kbutton-2 active:border active:border-kbutton-3 py-1 sm:py-2 px-4 sm:px-6 text-sm sm:text-base rounded focus:outline-none">
                  {{ $t("homeDash.apllyBtn") }}
                </button>
              </span>
            </div>
          </div>
        </div>
        <!-- mobile version calendar -->
      </div>

      <div v-if="purchases.length !== 0" class="bg-white col-span-1">
        <table class="w-full  table-auto xl:table-fixed text-sm border border-solid ffamily-pro">
          <thead class=" hidden lg:table-header-group font-bold text-left border border-bgk-2 border-solid">
            <th class="p-2 sm:p-3 ">{{ $t("homeDash.meterNumb") }}</th>
            <th>{{ $t("homeDash.metrAmount") }}</th>
            <th>{{ $t("homeDash.date") }}</th>
            <th>{{ $t("homeDash.action") }}</th>
          </thead>
          <tbody>
            <tr class="hover:bg-bgk-1 border border-bgk-2 border-solid" v-for="purchase in purchases"
              :key="purchase.id">
              <td class="flex flex-col p-3 ">
                <span class="text-sm">{{ purchase.counter }}</span>
                <span class="text-xs" style="color: #4D4C4C">{{
                  purchase.cUser
                }}</span>
              </td>
              <td class="text-right lg:text-left">
                <span>{{ purchase.amount }} Fcfa</span><br />
                <span class="lg:hidden">{{ purchase.date }}</span>
              </td>

              <td>
                <span class="hidden lg:table-cell">{{ purchase.date }}</span>
              </td>
              <td class="px-2 lg:px-0 w-8 lg:w-auto">
                <div class="lg:flex hidden">
                  <div class="flex items-center">
                    <button class="focus:outline-none mr-2" :title="$t('tooltip.downloadbill')" @click="downloadBill(purchase.transacId)">
                      <Icondownl />
                    </button>
                    <button class="focus:outline-none mr-2" :title="$t('tooltip.sendbill')" @click="passSendPurchase(purchase.transacId)">
                      <Iconsend />
                    </button>
                  </div>
                  <!-- <div class="border-l-2">
                    <button class="focus:outline-none flex  items-center ml-2" :title="$t('tooltip.renew')" @click="renouveller(purchase.counter, purchase.cUser)">
                      <Iconrefresh />
                      <span class="text-sm hidden lg:block font-semibold ml-2"
                        style="color: #0965F6;">{{ $t("homeDash.actionRefresh") }}</span>
                    </button>
                  </div> -->
                </div>
                <div class="lg:hidden">
                  <Icondatatabl @click="purchase.active = !purchase.active" class="" />
                  <div v-show="purchase.active == true" @click="purchase.active = !purchase.active"
                    class="absolute -ml-24  bg-white flex flex-col p-4 shadow-xs rounded">
                    <button class="focus:outline-none flex items-center mb-1" :title="$t('tooltip.downloadbill')" @click="downloadBill(purchase.transacId)">
                      <Icondownl class="mr-3" /><span>{{ $t("homeDash.actionDown") }}</span>
                    </button>
                    <button class="focus:outline-none flex items-center mb-1" :title="$t('tooltip.sendbill')" @click="passSendPurchase(purchase.transacId)">
                      <Iconsend class="mr-3" /><span>{{ $t("homeDash.actionSend") }}</span>
                    </button>
                    <button class="focus:outline-none flex items-center" :title="$t('tooltip.renew')" @click="renouveller(purchase.counter, purchase.cUser)">
                      <Iconrefresh class="mr-3" /><span>{{ $t("homeDash.actionRefresh") }}</span>
                    </button>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div v-show="pages.length > 1" class="p-4 text-right border  border-bgk-2">
          <nav>
            <ul>
              <li>
                <button :class="
                    currentPage === pageNumber
                      ? 'bg-red-600 text-white'
                      : 'bg-white'
                  " class="focus:outline-none  text-center text-xs rounded-full h-5 w-5 "
                  v-for="pageNumber in pages" :key="pageNumber.id" @click="gotoPage(pageNumber)">
                  {{ pageNumber }}
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <div v-else class="bg-white rounded h-statedt">
          <div class="mx-auto" style="height: 300px; width:300px"><img src="@/assets/gifts/dataTableEmpty.gif" alt=""></div>
          <div class="mt-16 text-xl text-center">{{ $t("homeDash.datatableEmpty") }}</div>
      </div>
    </div>
    <KdSendModal @success="onSendSuccess" @fail="onSendFail" />
  </div>
  
</template>

<script>
import KdSendModal from "./kdSendModal";
import VcDatePicker from 'v-calendar/lib/components/date-picker.umd'
import Iconcompt2 from "../../assets/svg/dashbIcons/compteurlogo.svg?inline";
import Iconsave from "../../assets/svg/dashbIcons/save.svg?inline";
import Iconpay from "../../assets/svg/dashbIcons/paymentcard.svg?inline";
import Icondownl from "../../assets/svg/dashbIcons/downloadblue.svg?inline";
import Iconsend from "../../assets/svg/dashbIcons/sendgreen.svg?inline";
//import Iconrefresh from "../../assets/svg/dashbIcons/refresh.svg?inline";
import Icondatatabl from "../../assets/svg/dashbIcons/datatablmb.svg?inline";
import Iconchevroncal from "../../assets/svg/dashbIcons/chevroncalendar.svg?inline";
import Iconcalendar from "../../assets/svg/dashbIcons/calendar.svg?inline";
import Iconchevrdate from "../../assets/svg/dashbIcons/chevronDate.svg?inline";
import IconSuccess from "../../assets/svg/icons/toascheck.svg?inline";
import IconError from "../../assets/svg/icons/toasterror.svg?inline";
import ToastMessage from '../../components/ToastMessage.vue';
export default {
  components: {
    Iconcompt2,
    Iconsave,
    Iconpay,
    Icondownl,
    Iconsend,
    //Iconrefresh,
    Icondatatabl,
    Iconchevroncal,
    Iconcalendar,
    KdSendModal,
    Iconchevrdate,
    IconSuccess,
    IconError,
    ToastMessage,
    VcDatePicker
  },
  data() {
    return {
      calFilter: [this.$i18n.t("homeDash.calBtn"),this.$i18n.t("homeDash.today"), this.$i18n.t("homeDash.passWeek") ,this.$i18n.t("homeDash.passMonth") , this.$i18n.t("homeDash.passYear")],
      selectedFilter: this.$i18n.t("homeDash.calBtn"),
      chooseDate: false,
      calendar: false,
      showToast: false,
      //checkin: '',
      page: 1,
      pages: [],
      range: {
        start: '', // Jan 16th, 2018
        end: '', // Jan 19th, 2018
      },

      filterRange: {
        startDate: 'allTime',
        endDate: 'endAllTime'
      },
      toast : {
          show: false,
          message: "",
          icon: 'IconSuccess',
          color: 'bg-bgk-3'
      }
      
    };
  },

  methods: {
    addMeter(){
      this.$store.commit('mutAddCounter',true)
    },
    timeFilter(filter){
      this.selectedFilter = filter
      
      if(filter == this.$i18n.t("homeDash.calBtn")) {
        this.filterRange = {
          startDate: 'allTime',
          endDate: 'endAllTime'
        }
        this.getPurchases(1, this.filterRange)
      }
      else if(filter == this.$i18n.t("homeDash.today")){
        let today = new Date()
        let tomorrow = new Date(today)
        tomorrow.setDate(tomorrow.getDate() + 1)
        today = today.toISOString().slice(0, 10)
        tomorrow = tomorrow.toISOString().slice(0, 10)
        console.log(today,tomorrow)
        this.filterRange = {
          startDate: today,
          endDate: tomorrow
        }
        console.log(this.filterRange)
        this.getPurchases(1, this.filterRange)
      }
      else if(filter == this.$i18n.t("homeDash.passWeek")){
        let today = new Date()
        let weekAgo = new Date(today)
        weekAgo.setDate(weekAgo.getDate() - 7)
        today = today.toISOString().slice(0, 10)
        weekAgo = weekAgo.toISOString().slice(0, 10)
        console.log(today,weekAgo)
        this.filterRange = {
          startDate: weekAgo,
          endDate: today
        }
        console.log('week',this.filterRange)
        this.getPurchases(1, this.filterRange)
      }
      else if(filter == this.$i18n.t("homeDash.passMonth")){
        let today = new Date()
        let monthAgo = new Date(today)
        monthAgo.setDate(monthAgo.getDate() - 30)
        today = today.toISOString().slice(0, 10)
        monthAgo = monthAgo.toISOString().slice(0, 10)
        console.log(today,monthAgo)
        this.filterRange = {
          startDate: monthAgo,
          endDate: today
        }
        this.getPurchases(1, this.filterRange)
      }
      else if(filter == this.$i18n.t("homeDash.passYear")){
        let today = new Date()
        let yearAgo = new Date(today)
        yearAgo.setDate(yearAgo.getDate() - 365)
        today = today.toISOString().slice(0, 10)
        yearAgo = yearAgo.toISOString().slice(0, 10)
        console.log(today,yearAgo)
        this.filterRange = {
          startDate: yearAgo,
          endDate: today
        }
        this.getPurchases(1, this.filterRange)
      }
      this.calendar = !this.calendar
    },

    applyFilter(){
      console.log(this.range)
        if (! this.range) {
          console.log('not range date');
          this.showToast = true
          return
        }
        let start = new Date(this.range.start)
        start.setDate(start.getDate() + 1)
        let end = new Date(this.range.end)
        end.setDate(end.getDate() + 1)
        start = start.toISOString().slice(0, 10)
        end = end.toISOString().slice(0, 10)
        console.log('start'+start,end)
        this.filterRange = {
          startDate: start,
          endDate: end
        }
        console.log('datePicker',this.filterRange)
        this.getPurchases(1, this.filterRange)
        this.calendar = !this.calendar
    },
    
    downloadBill(transacId){
      this.$store.dispatch('downloadBillRequest', transacId)
      .then(data => {
        window.open(data, '_blank');
      })
      .catch(() => {
        const toast = {
          show: true,
          message: this.$t("rechargeSuccess.downloadErrorMessage"),
          icon: 'IconError',
          color: 'bg-bgk-6'
        }
        this.toast = toast
      })
    },
    renouveller(numb, user){
      const meter = {
          cNumb: numb,
          cUser: user
      }
      this.$store.commit('mutSelectedMeter', meter)
      this.$store.commit('mutCheckArrear')
      this.$router.push("/dashboard/recharge");
    },
    calendarActive() {
      this.chooseDate=false;
      this.calendar = !this.calendar;
    },
    getPurchases(page, filter) {
      const data = {
        page: page,
        startDate: filter.startDate,
        endDate: filter.endDate
      }
      this.$store.commit("mutPurchase", data);
    },
    gotoPage(pageNumber){
      this.page = pageNumber;
      this.getPurchases(pageNumber, this.filterRange)
    },
    setPages() {
      let numberOfpages = Math.ceil(this.numbOfPages);
      this.pages = []
      for (let index = 1; index <= numberOfpages; index++) {
        this.pages.push(index);
      }
    },
    
    passDeletePurchase(id) {
      this.$store.commit("mutPurchaseId", id);
      this.$store.commit("mutTrashPurchase", true);
    },
    passSendPurchase(id) {
      this.$store.commit("mutTransacId", id)
      this.$store.commit("mutSendPurchase", true);
    },
    onSendSuccess(){
      const toast = {
        show: true,
        message: this.$t("rechargeSuccess.toastMessage"),
        icon: 'IconSuccess',
        color: 'bg-bgk-3'
      }
      this.toast  = toast
    },

    onSendFail() {
       const toast = {
          show: true,
          message: this.$t("rechargeSuccess.toastErrorMessage"),
          icon: 'IconError',
          color: 'bg-bgk-6'
      }
      this.toast  = toast
    }
  },
  computed: {
    purchases() {
      return this.$store.getters.getPurchases;
    },
    numbOfPages(){
      return this.$store.getters.getNumbOfPages;
    },
    
    currentPage() {
      return this.page;
    },
    theme() {
      return {
        arrows:"text-black vc-rounded vc-border-2 vc-border-transparent hover:vc-opacity-50 hover:vc-bg-gray-300 focus:vc-border-gray-300",
        bgAccentHigh:"bg-tex-2",
        bgAccentLow:"bg-white",
        bgLow:"bg-tex-2 vc-border-2 vc-border-tex-2",
        color:"red",
        container:"text-black text-base font-normal vc-bg-white",
        contentAccent:"text-black",
        contentAccentContrast:"vc-text-white",
        dayContent:"text-black",
        dayContentDisabled:"vc-text-gray-400",
        header:"text-black",
        weekdays: "text-black",
        highlightBaseFillMode:"light",
        highlightBaseClass:"",
        highlightBaseContentClass: "bg-tex-9",
        highlightStartEndClass:"",
        highlightStartEndFillMode:"solid",
        highlightStartEndContentClass: "bg-tex-2",
        headerTitle: "text-black"

      }
    }
    

  },
  watch: {
        numbOfPages () {
            this.setPages();
        }
    },
  mounted() {
    //this.getPurchases(1);
     const data = {
        page: 1,
        startDate: 'allTime',
        endDate: 'endAllTime'
      }
      this.$store.commit("mutPurchase", data);
    this.setPages();
  },
  
};
</script>

<style scoped>

.bg-lg {
  background-image: url(../../assets/svg/SBEEA1.svg);
  background-repeat: no-repeat;
  background-position: left bottom;
  background-size: cover;
}

@media (min-width: 640px) {
  .bg-lg {
    background-image: url(../../assets/svg/Bg.svg);
    background-repeat: no-repeat;
    background-position: left bottom;
    background-size: cover;
  }
}
</style>
